import selectors from '../rootSelectors';
import { selectPossibleResponse } from '../common/questions/questionsActions';
import { activateNextButton } from '../common/screen/screenActions';
import VocaboServiceClient from '../common/clients/VocaboServiceClient';

export const SET_VOCAB_CONTENT = {
    TQVM: 'SET_VOCAB_TQVM_CONTENT',
    FITB: 'SET_VOCAB_FITB_CONTENT',
    BD: 'SET_VOCAB_BD_CONTENT',
};

export const setVocabContent = (content, measure) => ({
    type: SET_VOCAB_CONTENT[measure],
    content,
});

export const fetchContent = (measure, fetchVocabAction) => {
    return (dispatch, getState) => {
        const state = getState();
        const grade = selectors.getGrade(state);
        const period = selectors.getToy(state);
        const language = selectors.getCurrentLanguage(state);

        return dispatch(
            VocaboServiceClient.getForm(measure, grade, period, language, fetchVocabAction),
        ).then(contentJson => {
            if (contentJson instanceof Array) {
                const content = contentJson.length > 0 ? contentJson[0] : contentJson;

                dispatch(setVocabContent(content, VocaboServiceClient.MEASURES[measure]));
            }
        });
    };
};

export const onResponseSelect = response => dispatch => {
    dispatch(selectPossibleResponse(response));
    dispatch(activateNextButton());
};
